
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios';


import eventosModule from '@/store/eventos'
import authModule from '@/store/auth'
import errorsModule from '@/store/errors'
import encuestasModule from '@/store/encuestas'
import dominiosModule from '@/store/dominios'
import documentacionModule from '@/store/documentacion'
import guiaOrientacionModule from '@/store/guia-orientacion'
import stylesModule from '@/store/styles'
import infoPopupModule from '@/store/popup-info'
import practicaOnline from '@/store/practica-online'
import notificaciones from '@/store/notificaciones'
import comunicaciones from '@/store/comunicaciones'
import filtros from '@/store/filtros'
import programas from '@/store/programas-practicas'

import CVModule from '@/store/cv'
import accionesAlumnoModule from '@/store/accionesAlumno'

import accionesEmpresaModule from '@/store/accionesEmpresa'

import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorCa from '@/validator/ca';

import messages from '@/translations';

import { langdetector } from '@/langdetector';

import i18n from '../i18n';

import servers from '@/servers'


import appinfo from '../../package.json';

import { brandDetector } from '@/brands';

let brandStyles = brandDetector();

let domain = 'https://backoffice.empleo.uax.es';
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.includes('dev.doubledot.es')) {
  domain = 'https://sandbox-uax.dotia.es';
}

//SET IDIOMA
localStorage.setItem('language', langdetector());


import * as Sentry from '@sentry/browser';
Sentry.setTag("dotia_version", appinfo.version);

let lang;

if (window.localStorage.getItem('_idIdiomaPreferido')) {
  lang = window.localStorage.getItem('_idIdiomaPreferido');
} else if (brandStyles.languagebydefault && !lang) {
  lang = brandStyles.languagebydefault;
} else {
  lang = "es";
}


export const store = new Vuex.Store({
  state: {
    language: lang,
    server: domain,
    loading: false,
    darkSide: window.localStorage.getItem('darkmode') || "false",
    packageVersion: appinfo.version
  },
  actions: {
    changeLanguage: ({ commit, dispatch, getters }, nextlang) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', nextlang);
        switch (nextlang) {
          case "es":
            Validator.localize('es', validatorEs);
            break;
          case "ca":
            Validator.localize('ca', validatorCa);
            break;
        }

        if (getters.getLogged) {
          dispatch('requestDominios');

          if(getters.getUserType == 'Alumno'){
            dispatch('requestParamsOfertas')
            dispatch('requestCV')
          }
          
                  let lang = { "idIdioma": nextlang };
          
                  axios.post(`api/${getters.getUserType}/editarIdiomaPreferido`, lang).then(response => {
                    window.localStorage.setItem('_idIdiomaPreferido',nextlang);
                    resolve(true);
                  }).catch(function (error) {
                      commit('setError', 500);
                      resolve(false);
                      dispatch('sendErrorServer', error.response);
                    });
        }

        i18n.locale = nextlang;

        resolve(nextlang);
      });
    },
    setLoading: ({ commit }, value) => {
      commit('setLoading', value);
    },
    toggleDarkSide: ({ commit }) => {
      commit('setToggleDarkSide');
    },
    checklang: ({ dispatch, getters }, lang) => {
      if (getters.getLanguage != lang) {
        dispatch('changeLanguage', lang);
      }
    }

  },
  getters: {
    getLanguage: state => state.language,
    getServer: state => state.server,
    getLoading: state => state.loading,
    getDarkSide: state => JSON.parse(state.darkSide),
    getTexts: state => {
      return messages[state.language];
    },
    getVersion: state => state.packageVersion,
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setToggleDarkSide(state) {
      state.darkSide = !state.darkSide;
      window.localStorage.setItem("darkmode", state.darkSide);
      if (state.darkSide) {
        document.getElementsByTagName("body")[0].classList.add("dark");
      } else {
        document.getElementsByTagName("body")[0].classList.remove("dark");
      }
    },
  },
  modules: {
    eventosModule,
    authModule,
    errorsModule,
    encuestasModule,
    dominiosModule,
    documentacionModule,
    guiaOrientacionModule,
    CVModule,
    accionesAlumnoModule,
    accionesEmpresaModule,
    stylesModule,
    infoPopupModule,
    practicaOnline,
    notificaciones,
    comunicaciones,
    filtros,
    programas
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js